import respondentInfoQuestionTypes from './respondentInfoQuestionTypes';

export default {
  ...respondentInfoQuestionTypes,
  respondentBlankField: 'questioncustomerblank',
  respondentCompanyName: 'questioncustomercompanyname',
  respondentFirstName: 'questioncontactfirstname',
  respondentLastName: 'questioncontactlastname',
  respondentPhone: 'questioncontactphonenumber',
  respondentMail: 'questioncontactemail',
  headerImage: 'header_image',
  staticText: 'text',
  longText: 'questiontextmultiline',
  questionImageSingle: 'questionimagesingle',
  questionImageMulti: 'questionimagemulti',
  questionSingle: 'questionradio',
  questionDropdown: 'questiondropdown',
  questionMatrixRadio: 'questionmatrixradio',
  questionMatrixMulti: 'questionmatrixmulti',
  questionMatrixScale: 'questionmatrixscale',
  questionMulti: 'questionmulti',
  questionScale: 'questionscale',
  questionNumeric: 'questionnumeric',
  redirectButton: 'redirect_button',
  shortText: 'questiontext',
  socialFollow: 'socialfollow',
  nextButton: 'next_button',
  submitButton: 'submit_button',
};
